'use client'
import { useContentFromRoute } from "@/contexts/ContentRouteProvider";
import { useRedirectProvider } from "@/contexts/RedirectProvider";
import { searchParamsVersionedContent } from "@/lib/searchParams";
import { preferences } from "@/redux/features/versions";
import { useAppSelector } from "@/redux/hooks";
import { DrupalNode } from "@/types";
import { DrupalTaxonomyTerm } from "next-drupal";
import { permanentRedirect } from "next/navigation";
import { useQueryStates } from "nuqs";
import { ReactNode, useEffect, useMemo } from "react";

export const LateRedirectHandler = ({children}: {
  children: ReactNode
}) => {
  const redirect = useRedirectProvider()

  useEffect(() => {
    const hash = window.location.hash;
    // Check if redirect is presnt and append the section hash at the end of redirect.
    if (redirect !== undefined) {
      permanentRedirect(redirect.to+hash)
    }
  }, [redirect])
  
  const { resource } = useContentFromRoute<DrupalNode>()
  const versions = useMemo(() => {
    return resource?.field_product_version?.map((t:DrupalTaxonomyTerm) => t.name) ?? []
  }, [resource?.field_product_version])

  const [params, setParams] = useQueryStates(searchParamsVersionedContent)
  const product = resource?.field_product

  const productPreferences = useAppSelector(preferences)
  const userPreferredVersion = productPreferences[product.name] ?? undefined
  const version = userPreferredVersion ?? versions.pop()

  useEffect(() => {
    // Set a default version when applicable and none provided.
    if (!params.v && version) {
      setParams({
        ...params,
        v: version
      })
    }
    // If the version provided is not available, default to version.
    if (params.v && ![version, ...versions].includes(params.v)) {
      setParams({
        ...params,
        v: version
      })
    }
  }, [params, version, versions, setParams])

 
  return <>{children}</>
}